import gql from 'graphql-tag';

export const commentsQuery = gql`
  query Comments {
    comments {
      id
      recipientId
      userId
      commentText
      createdAt
    }
  }
`;
